import React, { useState, useEffect } from 'react'
import styled, { withTheme } from 'styled-components'
import LandingContent from './sections/content/LandingContent'
import Carousel from './sections/carousel/Carousel.js'
import Footer from './sections/content/snippets/Footer'
import {MAHABALIPURAM, NAINITAL, MYSORE} from './sections/carousel/carousel-constants.js'
import { Parallax, ParallaxProvider } from 'react-scroll-parallax'

import data from '../assets/data.json'

const Container = styled(ParallaxProvider)`
    width: 100%;
    height:100%;
`
const LandingWrapper = styled.div`
    position: relative;
    overflow-x: hidden;
`;

const TransitionGradient = styled(Parallax)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 80px;
    z-index: 100;

    .parallax-inner {
        transition: transform 300ms cubic-bezier(.39,.58,.57,1);
    }

`;

const Gradient = styled.div`
    width: 100%;
    height: 100px;
    background: linear-gradient(180deg, ${props => props.color} 51%, ${props => props.color + '00' } 100%); ;
`;

const Landing = (props) => {

    const [selectedCity, setSelectedCity] = useState(null);
    const [slides, setSlides] = useState([MAHABALIPURAM, NAINITAL, MYSORE]);
    const [footerSlides, setFooterSlides] = useState([MAHABALIPURAM, NAINITAL, MYSORE]);

    function changeSelectedCity (activeCity) {
        setSelectedCity(activeCity); 
    }

    useEffect(() => {
        if (selectedCity && footerSlides.includes(selectedCity)) {
            const footerSelection = slides.filter(slide => {
                const shouldAppear = slide !== selectedCity;
                return shouldAppear;
            });
            setFooterSlides(footerSelection);
        }
    }, [selectedCity, footerSlides]);
        

    return (
        <Container>
            <Carousel onExploreClick={changeSelectedCity} slides={slides} displayedCity={selectedCity}></Carousel>
            {selectedCity &&
                <LandingWrapper>
                    <TransitionGradient y={[0,-350]}>
                        <Gradient color={data[selectedCity].bodyBackground}></Gradient>
                    </TransitionGradient>
                    <LandingContent
                        backgroundColor={data[selectedCity].bodyBackground}
                        cityName={data[selectedCity].cityName}
                        mapImage={data[selectedCity].mapSrc}
                        mapImageAlt={data[selectedCity].mapImageAlt}
                        pinImage={data[selectedCity].pinSrc}
                        pinImageAlt={data[selectedCity].pinImageAlt}
                        bgPositionX={data[selectedCity].bgPositionX}
                        bgPositionY={data[selectedCity].bgPositionY}
                        pinPositionX={data[selectedCity].pinPositionX}
                        pinPositionY={data[selectedCity].pinPositionY}
                        introText={data[selectedCity].introText}
        
                        text1={data[selectedCity].text1}
                        image1Src={data[selectedCity].img1Src}
                        image1Ref={data[selectedCity].img1Ref}
                        photoSource={data[selectedCity].photoSrc}
        
                        image2Src={data[selectedCity].img2Src}
                        image2Ref={data[selectedCity].img2Ref}
                        image3Src={data[selectedCity].img3Src}
                        image3Ref={data[selectedCity].img3Ref}
        
                        quoteImageSrc={data[selectedCity].quoteImg}
                        quoteContent={data[selectedCity].quote}
                        quoteBg={data[selectedCity].quoteBg}
        
                        textBg={data[selectedCity].backgroundSrc}
                        text2={data[selectedCity].text2}
                        image4Src={data[selectedCity].img4Src}
                        image4Ref={data[selectedCity].img4Ref}
                        image5Src={data[selectedCity].img5Src}
                        image5Ref={data[selectedCity].img5Ref}
                        image6Src={data[selectedCity].img6Src}
                        image6Ref={data[selectedCity].img6Ref}
                        text3={data[selectedCity].text3}
        
                        image7Src={data[selectedCity].img7Src}
                        image7Ref={data[selectedCity].img7Ref}
                        image8Src={data[selectedCity].img8Src}
                        image8Ref={data[selectedCity].img8Ref}
                        text4={data[selectedCity].text4}>
                    </LandingContent> 
                    <Carousel onExploreClick={changeSelectedCity} slides={footerSlides} footer={true} displayedCity={selectedCity}></Carousel>
                    <Footer />
                </LandingWrapper>
            }
        </Container>
    );
};

export default withTheme(Landing);